<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
    <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="_id"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chConsoleSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="chConsoleLabel"> </v-text-field>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Total of Sensor</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-radio-group
      v-model="totalSensor"
      row
    >
      <v-radio
        label="1"
        value= 1
      ></v-radio>
      <v-radio
        label="2"
        value= 2
      ></v-radio>
      <v-radio
        label="3"
        value= 3
      ></v-radio>
      <v-radio
        label="4"
        value= 4
      ></v-radio>
    </v-radio-group>
        </v-col>
        <v-col cols="2">
        </v-col>
      </v-row>
    </v-card>

   <v-card-title v-if="totalSensor == 1 || totalSensor == 2 || totalSensor == 3 || totalSensor == 4">Sensor Unit 1</v-card-title>
    <v-card v-if="totalSensor == 1 || totalSensor == 2 || totalSensor == 3 || totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1A"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1A.label"
        ></v-select>
        </v-col>
      </v-row>

    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1B"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1B.label"
        ></v-select>
        </v-col>
      </v-row>

    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1C"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1D"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
          <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1E"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1F"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1G"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel1"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn1"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName1H"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location1H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_1H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_1H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_1H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb1H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb1H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb1H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>

<v-card-title v-if="totalSensor == 2 || totalSensor == 3 || totalSensor == 4">Sensor Unit 2</v-card-title>
    <v-card v-if="totalSensor == 2 || totalSensor == 3 || totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2A"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2B"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2C"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2D"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2E"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2F"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2G"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel2"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn2"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName2H"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location2H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_2H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_2H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_2H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb2H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb2H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb2H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-card>

<v-card-title v-if="totalSensor == 3 || totalSensor == 4">Sensor Unit 3</v-card-title>
   <v-card v-if="totalSensor == 3 || totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3A"></v-text-field>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3B"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
         </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3C"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3D"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3E"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
         <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3F"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3G"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel3"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn3"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName3H"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location3H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_3H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_3H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_3H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb3H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb3H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb3H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
   </v-card>

<v-card-title v-if="totalSensor == 4">Sensor Unit 4</v-card-title>
   <v-card v-if="totalSensor == 4">
    <v-card-title>A</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4A"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4A"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4A" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4A(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4A">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4A.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4A.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4A.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>B</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4B"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4B"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4B" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4B(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4B">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4B.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4B.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4B.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>C</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4C"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4C"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4C" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4C(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4C">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4C.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4C.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4C.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

      <v-card-title>D</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4D"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4D"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4D" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4D(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4D">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4D.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4D.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4D.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card-title>E</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4E"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4E"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4E" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4E(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4E">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4E.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4E.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4E.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>F</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4F"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4F"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4F" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4F(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4F">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4F.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4F.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4F.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>G</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4G"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4G"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4G" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4G(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4G">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4G.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4G.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4G.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>

     <v-card-title>H</v-card-title>
   <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor Label</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="chSensorLabel4"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>8CH Current Sensor S/N</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="chSensorSn4"
            label="Serial Number*"
            >
            </v-select>
          </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>DB Name</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-text-field v-model="boardName4H"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>Location</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="location"
            item-value="_id"
            :item-text="
            (location) => {
            return (location.location);
            }"
            v-model="location4H"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
           <v-subheader>Load Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in loadType_4H" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="loadTypeItems"
          label="Select Load Type"
          v-model="type.mainLoadType"
        ></v-select>
      </v-col>
              <v-col cols="2">
            <v-select
            v-if="type.mainLoadType === 'User Wall Switches'"
              :items="userWallItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
            <v-select
            v-if="type.mainLoadType === 'Direct From DB'"
              :items="directItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
             <v-select
            v-if="type.mainLoadType === 'Main Socket'"
              :items="mainItems"
              :label="'Load Type' + ' ' + (idx + 1)"
              v-model="type.loadType"
            ></v-select>
              </v-col>
          <v-col cols="2">
            <v-text-field
            v-if="type.loadType != ''"
              :label="'Quantity' + ' ' + (idx + 1)"
              v-model="type.quantity"
            ></v-text-field>
  </v-col>
  <v-col cols="2">
            <v-icon
            @click="deleteLoadType_4H(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewLoadType_4H">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>

       <v-row>
        <v-col cols="2">
          <v-subheader>Phase Type</v-subheader>
        </v-col>
        <v-col cols="2">
          <v-select
          :items="phaseType"
          label="RYB Phase"
          v-model="ryb4H.phase"
        ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
          v-if="ryb4H.phase != ''"
          :items="rybLabel"
          label="RYB Label"
          v-model="ryb4H.label"
        ></v-select>
        </v-col>
      </v-row>
    </v-card>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: '8 Channel Phase',
          disabled: false,
          href: '/board',
        },
        {
          text: 'Add',
          disabled: true,
          href: '',
        }
      ],
    loadTypeItems: ['User Wall Switches', 'Direct From DB', 'Main Socket'],
    userWallItems: ['Lighting', 'Fan', 'Aircond', 'Water Heater', 'Ventilation Fan'],
    directItems: ['Emergency Light', 'KELUAR Sign', 'Lift'],
    mainItems: ['TV', 'Hand Dryer', 'IT equipment', 'Washing Machine', 'Refrigerator', 'Cooking Ovens', 'Rail Sockets', 'Others'],
    location: [],
    phaseType: ['R','Y','B'],
    rybLabel: ['1R','1Y','1B','2R','2Y','2B','3R','3Y','3B','4R','4Y','4B','5R','5Y','5B','6R','6Y','6B','7R','7Y','7B','8R','8Y','8B','9R','9Y','9B','10R','10Y','10B','11R','11Y','11B'],
    mainLoadType: "",
    chConsoleLabel: "",
    chConsoleSn: "",
    totalSensor: null,
    loadType: "", 
    quantity: "",
    chSensorLabel1: "", 
    chSensorSn1: "",
    chSensorLabel2: "", 
    chSensorSn2: "",
    chSensorLabel3: "", 
    chSensorSn3: "",
    chSensorLabel4: "", 
    chSensorSn4: "",

    ryb1A: {
        phase : "",
        label : ""
    },
    boardName1A: "",
    location1A: "",
    loadType_1A:[],

    ryb2A: {
        phase : "",
        label : ""
    },
    boardName2A: "",
    location2A: "",
    loadType_2A:[],

    ryb3A: {
        phase : "",
        label : ""
    },
    boardName3A: "",
    location3A: "",
    loadType_3A:[],

    ryb4A: {
        phase : "",
        label : ""
    },
    boardName4A: "",
    location4A: "",
    loadType_4A:[],

    ryb1B: {
        phase : "",
        label : ""
    },
    boardName1B: "",
    location1B: "",
    loadType_1B:[],

    ryb2B: {
        phase : "",
        label : ""
    },
    boardName2B: "",
    location2B: "",
    loadType_2B:[],

    ryb3B: {
        phase : "",
        label : ""
    },
    boardName3B: "",
    location3B: "",
    loadType_3B:[],

    ryb4B: {
        phase : "",
        label : ""
    },
    boardName4B: "",
    location4B: "",
    loadType_4B:[],

    ryb1C: {
        phase : "",
        label : ""
    },
    boardName1C: "",
    location1C: "",
    loadType_1C:[],

    ryb2C: {
        phase : "",
        label : ""
    },
    boardName2C: "",
    location2C: "",
    loadType_2C:[],

    ryb3C: {
        phase : "",
        label : ""
    },
    boardName3C: "",
    location3C: "",
    loadType_3C:[],

    ryb4C: {
        phase : "",
        label : ""
    },
    boardName4C: "",
    location4C: "",
    loadType_4C:[],

    ryb1D: {
        phase : "",
        label : ""
    },
    boardName1D: "",
    location1D: "",
    loadType_1D:[],

    ryb2D: {
        phase : "",
        label : ""
    },
    boardName2D: "",
    location2D: "",
    loadType_2D:[],

    ryb3D: {
        phase : "",
        label : ""
    },
    boardName3D: "",
    location3D: "",
    loadType_3D:[],
    
    ryb4D: {
        phase : "",
        label : ""
    },
    boardName4D: "",
    location4D: "",
    loadType_4D:[],

    ryb1E: {
        phase : "",
        label : ""
    },
    boardName1E: "",
    location1E: "",
    loadType_1E:[],

    ryb2E: {
        phase : "",
        label : ""
    },
    boardName2E: "",
    location2E: "",
    loadType_2E:[],

    ryb3E: {
        phase : "",
        label : ""
    },
    boardName3E: "",
    location3E: "",
    loadType_3E:[],

    ryb4E: {
        phase : "",
        label : ""
    },
    boardName4E: "",
    location4E: "",
    loadType_4E:[],

    ryb1F: {
        phase : "",
        label : ""
    },
    boardName1F: "",
    location1F: "",
    loadType_1F:[],

    ryb2F: {
        phase : "",
        label : ""
    },
    boardName2F: "",
    location2F: "",
    loadType_2F:[],

    ryb3F: {
        phase : "",
        label : ""
    },
    boardName3F: "",
    location3F: "",
    loadType_3F:[],

    ryb4F: {
        phase : "",
        label : ""
    },
    boardName4F: "",
    location4F: "",
    loadType_4F:[],

    ryb1G: {
        phase : "",
        label : ""
    },
    boardName1G: "",
    location1G: "",
    loadType_1G:[],

    ryb2G: {
        phase : "",
        label : ""
    },
    boardName2G: "",
    location2G: "",
    loadType_2G:[],

    ryb3G: {
        phase : "",
        label : ""
    },
    boardName3G: "",
    location3G: "",
    loadType_3G:[],

    ryb4G: {
        phase : "",
        label : ""
    },
    boardName4G: "",
    location4G: "",
    loadType_4G:[],

    ryb1H: {
        phase : "",
        label : ""
    },
    boardName1H: "",
    location1H: "",
    loadType_1H:[],

    ryb2H: {
        phase : "",
        label : ""
    },
    boardName2H: "",
    location2H: "",
    loadType_2H:[],

    ryb3H: {
        phase : "",
        label : ""
    },
    boardName3H: "",
    location3H: "",
    loadType_3H:[],

    ryb4H: {
        phase : "",
        label : ""
    },
    boardName4H: "",
    location4H: "",
    loadType_4H:[],

    valid: true,
    serialNumber: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsSerialNumber();
      this.loadsLocation();
  },
  methods: {
    addNewLoadType_1A() {
      this.loadType_1A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1A(idx) {
      this.loadType_1A.splice(idx, 1);
    },
    addNewLoadType_2A() {
      this.loadType_2A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2A(idx) {
      this.loadType_2A.splice(idx, 1);
    },
    addNewLoadType_3A() {
      this.loadType_3A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3A(idx) {
      this.loadType_3A.splice(idx, 1);
    },
    addNewLoadType_4A() {
      this.loadType_4A.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4A(idx) {
      this.loadType_4A.splice(idx, 1);
    },

   addNewLoadType_1B() {
      this.loadType_1B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1B(idx) {
      this.loadType_1B.splice(idx, 1);
    },
    addNewLoadType_2B() {
      this.loadType_2B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2B(idx) {
      this.loadType_2B.splice(idx, 1);
    },
    addNewLoadType_3B() {
      this.loadType_3B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3B(idx) {
      this.loadType_3B.splice(idx, 1);
    },
    addNewLoadType_4B() {
      this.loadType_4B.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4B(idx) {
      this.loadType_4B.splice(idx, 1);
    },

    addNewLoadType_1C() {
      this.loadType_1C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1C(idx) {
      this.loadType_1C.splice(idx, 1);
    },
    addNewLoadType_2C() {
      this.loadType_2C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2C(idx) {
      this.loadType_2C.splice(idx, 1);
    },
    addNewLoadType_3C() {
      this.loadType_3C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3C(idx) {
      this.loadType_3C.splice(idx, 1);
    },
    addNewLoadType_4C() {
      this.loadType_4C.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4C(idx) {
      this.loadType_4C.splice(idx, 1);
    },

    addNewLoadType_1D() {
      this.loadType_1D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1D(idx) {
      this.loadType_1D.splice(idx, 1);
    },
    addNewLoadType_2D() {
      this.loadType_2D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2D(idx) {
      this.loadType_2D.splice(idx, 1);
    },
    addNewLoadType_3D() {
      this.loadType_3D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3D(idx) {
      this.loadType_3D.splice(idx, 1);
    },
    addNewLoadType_4D() {
      this.loadType_4D.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4D(idx) {
      this.loadType_4D.splice(idx, 1);
    },

    addNewLoadType_1E() {
      this.loadType_1E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1E(idx) {
      this.loadType_1E.splice(idx, 1);
    },
    addNewLoadType_2E() {
      this.loadType_2E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2E(idx) {
      this.loadType_2E.splice(idx, 1);
    },
    addNewLoadType_3E() {
      this.loadType_3E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3E(idx) {
      this.loadType_3E.splice(idx, 1);
    },
    addNewLoadType_4E() {
      this.loadType_4E.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4E(idx) {
      this.loadType_4E.splice(idx, 1);
    },

    addNewLoadType_1F() {
      this.loadType_1F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1F(idx) {
      this.loadType_1F.splice(idx, 1);
    },
    addNewLoadType_2F() {
      this.loadType_2F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2F(idx) {
      this.loadType_2F.splice(idx, 1);
    },
    addNewLoadType_3F() {
      this.loadType_3F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3F(idx) {
      this.loadType_3F.splice(idx, 1);
    },
    addNewLoadType_4F() {
      this.loadType_4F.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4F(idx) {
      this.loadType_4F.splice(idx, 1);
    },

    addNewLoadType_1G() {
      this.loadType_1G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1G(idx) {
      this.loadType_1G.splice(idx, 1);
    },
    addNewLoadType_2G() {
      this.loadType_2G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2G(idx) {
      this.loadType_2G.splice(idx, 1);
    },
    addNewLoadType_3G() {
      this.loadType_3G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3G(idx) {
      this.loadType_3G.splice(idx, 1);
    },
    addNewLoadType_4G() {
      this.loadType_4G.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4G(idx) {
      this.loadType_4G.splice(idx, 1);
    },

    addNewLoadType_1H() {
      this.loadType_1H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_1H(idx) {
      this.loadType_1H.splice(idx, 1);
    },
    addNewLoadType_2H() {
      this.loadType_2H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_2H(idx) {
      this.loadType_2H.splice(idx, 1);
    },
    addNewLoadType_3H() {
      this.loadType_3H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_3H(idx) {
      this.loadType_3H.splice(idx, 1);
    },
    addNewLoadType_4H() {
      this.loadType_4H.push({ loadType: this.loadType, quantity: this.quantity, mainLoadType: this.loadTypeItems });
    },
    deleteLoadType_4H(idx) {
      this.loadType_4H.splice(idx, 1);
    },

    loadsSerialNumber: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-available";
    axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/location";
    axios.get(apiURL).then(res => {
    this.location = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-board";
      axios
        .post(
      apiURL,
          {
    chConsoleLabel: this.chConsoleLabel,
    chConsoleSn: this.chConsoleSn,
    totalSensor: this.totalSensor,
    chSensorLabel1: this.chSensorLabel1,
    chSensorSn1: this.chSensorSn1,
    chSensorLabel2: this.chSensorLabel2,
    chSensorSn2: this.chSensorSn2,
    chSensorLabel3: this.chSensorLabel3,
    chSensorSn3: this.chSensorSn3,
    chSensorLabel4: this.chSensorLabel4,
    chSensorSn4: this.chSensorSn4,
    
    ryb1A: this.ryb1A,
    boardName1A: this.boardName1A,
    location1A: this.location1A,
    loadType_1A: this.loadType_1A,

    ryb2A: this.ryb2A,
    boardName2A: this.boardName2A,
    location2A: this.location2A,
    loadType_2A: this.loadType_2A,

    ryb3A: this.ryb3A,
    boardName3A: this.boardName3A,
    location3A: this.location3A,
    loadType_3A: this.loadType_3A,

    ryb4A: this.ryb4A,
    boardName4A: this.boardName4A,
    location4A: this.location4A,
    loadType_4A: this.loadType_4A,

    ryb1B: this.ryb1B,
    boardName1B: this.boardName1B,
    location1B: this.location1B,
    loadType_1B: this.loadType_1B,

    ryb2B: this.ryb2B,
    boardName2B: this.boardName2B,
    location2B: this.location2B,
    loadType_2B: this.loadType_2B,

    ryb3B: this.ryb3B,
    boardName3B: this.boardName3B,
    location3B: this.location3B,
    loadType_3B: this.loadType_3B,

    ryb4B: this.ryb4B,
    boardName4B: this.boardName4B,
    location4B: this.location4B,
    loadType_4B: this.loadType_4B,

    ryb1C: this.ryb1C,
    boardName1C: this.boardName1C,
    location1C: this.location1C,
    loadType_1C: this.loadType_1C,

    ryb2C: this.ryb2C,
    boardName2C: this.boardName2C,
    location2C: this.location2C,
    loadType_2C: this.loadType_2C,

    ryb3C: this.ryb3C,
    boardName3C: this.boardName3C,
    location3C: this.location3C,
    loadType_3C: this.loadType_3C,

    ryb4C: this.ryb4C,
    boardName4C: this.boardName4C,
    location4C: this.location4C,
    loadType_4C: this.loadType_4C,

    ryb1D: this.ryb1D,
    boardName1D: this.boardName1D,
    location1D: this.location1D,
    loadType_1D: this.loadType_1D,

    ryb2D: this.ryb2D,
    boardName2D: this.boardName2D,
    location2D: this.location2D,
    loadType_2D: this.loadType_2D,

    ryb3D: this.ryb3D,
    boardName3D: this.boardName3D,
    location3D: this.location3D,
    loadType_3D: this.loadType_3D,

    ryb4D: this.ryb4D,
    boardName4D: this.boardName4D,
    location4D: this.location4D,
    loadType_4D: this.loadType_4D,

    ryb1E: this.ryb1E,
    boardName1E: this.boardName1E,
    location1E: this.location1E,
    loadType_1E: this.loadType_1E,

    ryb2E: this.ryb2E,
    boardName2E: this.boardName2E,
    location2E: this.location2E,
    loadType_2E: this.loadType_2E,

    ryb3E: this.ryb3E,
    boardName3E: this.boardName3E,
    location3E: this.location3E,
    loadType_3E: this.loadType_3E,

    ryb4E: this.ryb4E,
    boardName4E: this.boardName4E,
    location4E: this.location4E,
    loadType_4E: this.loadType_4E,

    ryb1F: this.ryb1F,
    boardName1F: this.boardName1F,
    location1F: this.location1F,
    loadType_1F: this.loadType_1F,

    ryb2F: this.ryb2F,
    boardName2F: this.boardName2F,
    location2F: this.location2F,
    loadType_2F: this.loadType_2F,

    ryb3F: this.ryb3F,
    boardName3F: this.boardName3F,
    location3F: this.location3F,
    loadType_3F: this.loadType_3F,

    ryb4F: this.ryb4F,
    boardName4F: this.boardName4F,
    location4F: this.location4F,
    loadType_4F: this.loadType_4F,

    ryb1G: this.ryb1G,
    boardName1G: this.boardName1G,
    location1G: this.location1G,
    loadType_1G: this.loadType_1G,

    ryb2G: this.ryb2G,
    boardName2G: this.boardName2G,
    location2G: this.location2G,
    loadType_2G: this.loadType_2G,

    ryb3G: this.ryb3G,
    boardName3G: this.boardName3G,
    location3G: this.location3G,
    loadType_3G: this.loadType_3G,

    ryb4G: this.ryb4G,
    boardName4G: this.boardName4G,
    location4G: this.location4G,
    loadType_4G: this.loadType_4G,

    ryb1H: this.ryb1H,
    boardName1H: this.boardName1H,
    location1H: this.location1H,
    loadType_1H: this.loadType_1H,

    ryb2H: this.ryb2H,
    boardName2H: this.boardName2H,
    location2H: this.location2H,
    loadType_2H: this.loadType_2H,

    ryb3H: this.ryb3H,
    boardName3H: this.boardName3H,
    location3H: this.location3H,
    loadType_3H: this.loadType_3H,

    ryb4H: this.ryb4H,
    boardName4H: this.boardName4H,
    location4H: this.location4H,
    loadType_4H: this.loadType_4H,
    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>